import { render } from "./AddCommitmentModal.vue?vue&type=template&id=4f4c1126&scoped=true"
import script from "./AddCommitmentModal.vue?vue&type=script&lang=js"
export * from "./AddCommitmentModal.vue?vue&type=script&lang=js"

import "./AddCommitmentModal.vue?vue&type=style&index=0&id=4f4c1126&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f4c1126"]])

export default __exports__